import fetch from 'isomorphic-fetch';
import BaseApi from './BaseApi'

class TeamApi extends BaseApi {
  static index() {
    return this.getResponse(this.buildRequest(`/v1/teams.json`))
  }
}

export default TeamApi



// WEBPACK FOOTER //
// ./src/shared/javascripts/api/TeamApi.js